export default __webpack_public_path__ + "images/chat.svg?ecf5177fc7157e317144cdd22d5ceee2";